export default __webpack_public_path__ + "static/media/website.2ba61a87.svg";